// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import carrotIcon from "@/assets/icons/aop/carrot.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CarrotIconProps = Omit<IconProps, "name">;

export function CarrotIcon(props: CarrotIconProps): React.ReactNode {
  return <Icon name={carrotIcon} {...props} />;
}
